// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__26sPA","label":"Category_label__2sMGs","content":"Category_content__3VYkf","header":"Category_header__1UWfn","location":"Category_location__2cGYy"};